<template>
  <div v-if="isAdmin">
    <b-overlay :show="apiLoading" rounded="sm" spinner-variant="primary">
      <!-- Discount amount Input field -->
      <div class="mb-2 ml-auto d-flex align-items-center justify-content-end">
        <span class="mr-2" style="width: 150px;">Discount amount</span>
        <b-input-group
          prepend="$"
          class="btn-md"
          style="width: auto;"
        >
          <template #prepend>
            <span class="input-group-text" style="height: 30px; background-color: #eee">$</span>
          </template>

          <b-form-input
            :disabled="apiLoading"
            id="discount-amount"
            style="width:75px; height: 30px"
            v-integer-only="{ allowDecimal: true, currencyFormat: false }"
            v-model="manualDiscountAmount"
            placeholder=""
            @blur="saveDiscountAmount"
            @keyup.enter="saveDiscountAmount"
            @focus="$event.target.select()"
          />
        </b-input-group>
      </div>

      <!-- Manual shipping cost Input field -->
      <div class="mb-2 ml-auto d-flex align-items-center justify-content-end">
        <span class="mr-2" style="width: 150px;">Shipping cost</span>
        <b-input-group
          prepend="$"
          class="btn-md"
          style="width: auto;"
        >
          <template #prepend>
            <span class="input-group-text" style="height: 30px; background-color: #eee">$</span>
          </template>

          <b-form-input
            :disabled="apiLoading"
            id="shipping-cost"
            style="width:75px; height: 30px"
            v-integer-only="{ allowDecimal: true, currencyFormat: false }"
            v-model="manualShippingCost"
            placeholder=""
            @blur="saveShippingCost"
            @keyup.enter="saveShippingCost"
            @focus="$event.target.select()"
          />
        </b-input-group>
      </div>
    </b-overlay>

    <div class="mb-2 mt-2 ml-auto w-50">
        <span class="default-values-msg">
          To return to a default value,
          delete the value from the input box. When a shipping cost is specified manually, all shipping methods set to the specified cost.
          You can delete the specified cost to return to the default ones.
        </span>
    </div>
  </div>
</template>

<script>
import ApiMixin from "@core/mixin/ApiMixin"
import store from "../../../store"

export default {
  mixins: [ApiMixin],
  props: ["isAdmin"],
  data() {
    return {
      cart: store.state.cart,
      manualDiscountAmount: null,
      manualShippingCost: null,
      initialManualDiscountAmount: null,
      initialManualShippingCost: null
    }
  },
  name: "ManualDiscount",
  methods: {
    saveShippingCost() {
      if (this.manualShippingCost !== this.initialManualShippingCost) {
        this.post("cart/manual-shipping-cost", { "shipping_cost": this.manualShippingCost }, false)
          .then((cart) => {
            this.initialManualShippingCost = this.manualShippingCost = cart.shippingCost.amount
            // Update Store state of the Cart.
            store.updateCart(cart)
          })
          .catch((error) => {
            console.log("Error while saving shipping cost:", error)
          })
      }
    },
    saveDiscountAmount() {
      if (this.manualDiscountAmount !== this.initialManualDiscountAmount) {
        this.post("cart/manual_discount", { "discount_amount": this.manualDiscountAmount }, false)
          .then((cart) => {
            this.initialManualDiscountAmount = this.manualDiscountAmount = cart.manualDiscount?.amount
            // Update Store state of the Cart.
            store.updateCart(cart)
          })
          .catch((error) => {
            console.log("Error while saving discount amount:", error)
          })
      }
    },
    fetchCartManualValues() {
      if (this.cart.manualShippingCost?.amount) {
        this.initialManualShippingCost = this.manualShippingCost = this.cart.manualShippingCost?.amount
      }
      if (this.cart.manualDiscount?.amount) {
        this.initialManualDiscountAmount = this.manualDiscountAmount = this.cart.manualDiscount?.amount
      }
    }
  },
  mounted() {
    this.fetchCartManualValues()
  }
}
</script>

<style scoped>
.default-values-msg {
  text-align: right;
  color: #999;
  font-size: 12px;
  font-style: italic;
}
</style>
